/* @ngInject */
const utilsLimit = (
  utilsMath,
  valueHandler
) => {
  const self = {}

  self.step = 20
  self.current = self.step

  self.increaseLimit = () => {
    self.current += self.step
  }

  self.decreaseLimit = () => {
    self.current > 0 ? self.current -= self.step : self.current = 0
  }

  self.resetLimit = () => {
    self.current = self.step
  }

  self.getIncreaseStep = (_length, _limit, _step) => {
    if (!valueHandler.isNumber(_limit)) {
      _limit = self.current
    }
    if (!valueHandler.isNumber(_step)) {
      _step = self.step
    }
    return utilsMath.min(_step, utilsMath.max(_length - _limit, 0))
  }

  self.getDecreaseStep = (_length, _limit, _step) => {
    if (!valueHandler.isNumber(_limit)) {
      _limit = self.current
    }
    if (!valueHandler.isNumber(_step)) {
      _step = self.step
    }
    return utilsMath.min(_step, utilsMath.max(_length + _step - _limit, 0))
  }

  return self
}

export default utilsLimit



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/utils.limit.js